//include 17
jQuery(function () {
    /*
	var getReplacementUrl = function(width,height){
		return "https://placehold.it/"+width+"x"+height+"/FFC107/000000";
	};

	var replaceImage = function(imgElement){
		var currentSrc = imgElement.attr("src");
		var matches = currentSrc.match(/w=([^&]+)&h=([^&]+)/);
		if(matches.length >= 3){
			var width = matches[1];
			var height = matches[2];
			if(!isNaN(width) && !isNaN(height)){
				imgElement.attr("src",getReplacementUrl(width,height));
				return;
			}
		}	
		imgElement.attr("src",getReplacementUrl(100,100));
	}
//*/

    var defaultReplacementUrl = window.pixelpoint.domainService.get('apiEndpoint') + "[type]/[id]/placeholder?first=1"; //"https://placehold.it/[width]x[height]/FFC107/000000";
    var fallbackUrl = window.ppsettings.imageFallback;

    var errorCallbacks = {};

    var privateFunctions = {
        getReplacementUrl: function ($element, /*width,height*/ type, id) {
            var replacementUrl = $element.data("alternative-url");
            if (!replacementUrl) {
                replacementUrl = defaultReplacementUrl;
            }
            return replacementUrl.replace("[type]", type).replace("[id]", id);
        },
        getFallbackUrl: function ($element, width, height) {
            var replacementUrl = $element.data("alternative-url");
            if (!replacementUrl) {
                replacementUrl = fallbackUrl;
            }
            return replacementUrl.replace("[width]", width).replace("[height]", height);
        },
        /**
         * finds the dimensions from either a data attribute or from src directly. It does not get dimensions from html/css!
         * @param  {node} $element the jquery element for which to get dimensions
         * @return {object}          the width and height
         */
        getDimensions: function ($element) {
            var width = $element.data("width");
            var height = $element.data("height");
            var src = $element.attr("src");
            var srcWidth, srcHeight;
            if (!!src) {
                var matches = src.match(/w=([^&]+)&h=([^&]+)/);
                if (!!matches && !!matches.length && matches.length >= 3) {
                    srcWidth = matches[1];
                    srcHeight = matches[2];
                    if (!isNaN(matches[1])) {
                        srcWidth = matches[1];
                    }
                    if (!isNaN(matches[2])) {
                        srcHeight = matches[2];
                    }
                }
            }
            if (!width && !!srcWidth) {
                width = srcWidth;
            }
            if (!height && !!srcHeight)
                height = srcHeight;
            return {
                width: width,
                height: height
            };
        },
        getTypeAndId: function ($element) {
            var type = $element.data("type") || "poi";
            var id = $element.data("id") || 0;

            var src = $element.attr("src");
            var srcType, srcId;

            if (!!src) {
                let searchStr = window.pixelpoint.domainService.get('apiEndpoint').replace('https://', '//');
                if (src.search(searchStr) == -1) {
                    srcType = "";
                    srcId = 0;
                } else {
                    var matches = src.match(/\/api\/([a-zA-Z]+\/)*asset\/([\d]+)\/thumbnail/);
                    if (!!matches && !!matches.length && matches.length >= 2) {
                        srcType = "";
                        srcId = 0;
                        if (!!matches[1]) {
                            srcType = matches[1].substring(0, matches.length - 1); // first match ends with a /, if not empty
                        }
                        if (matches.length >= 3 && !isNaN(matches[2])) {
                            srcId = matches[2];
                        }
                    }
                }
            }

            srcType = srcType || type;
            srcId = id; //srcId || id; //the id in the url is from the image!!!!!!!

            return {
                type: srcType,
                id: srcId
            };
        },
        replaceWithAlternative: function ($element) {
            var dimensions = this.getDimensions($element);
            var replacementUrl = null;
            if (!!dimensions.width && !!dimensions.height)
                replacementUrl = this.getFallbackUrl($element, dimensions.width, dimensions.height);
            else
                replacementUrl = this.getFallbackUrl($element, 500, 500);
            privateFunctions.replaceImageUrl($element, replacementUrl, true);
        },
        replaceImage: function ($element) {
            var dimensions = this.getDimensions($element);
            var typeAndId = this.getTypeAndId($element);

            var replacementUrl;
            var fallbackUsed = false;
            if (typeAndId.id == 0) {
                if (!!dimensions.width && !!dimensions.height)
                    replacementUrl = this.getFallbackUrl($element, dimensions.width, dimensions.height);
                else
                    replacementUrl = this.getFallbackUrl($element, 500, 500);
                fallbackUsed = true;
            } else {
                replacementUrl = this.getReplacementUrl($element, typeAndId.type, typeAndId.id);
            }

            privateFunctions.replaceImageUrl($element, replacementUrl, fallbackUsed);
        },
        replaceImageUrl: function ($element, replacementUrl, fallbackUsed) {
            var containImage = $element.data("contain");

            $element.attr("src", replacementUrl);
            var $centerCropped = $element.closest(".center-cropped");
            if ($centerCropped.length > 0) {
                //$centerCropped.css("background-image", 'url(' + replacementUrl + ')');
                //$centerCropped.css({"background-image":"url(" + replacementUrl + ")", "background-color":"hsla(0,0%,79%,0.1)"}); // $medium-gray
                // remove Background https://ticket.pixelpoint.at/issues/30139#note-76
                /*
                $centerCropped.css({
                    "background-image": "url(" + replacementUrl + ")",
                    "background-color": "#E9EEF2"
                });
                */
                $centerCropped.css({"background-image": "url(" + replacementUrl + ")"});
                // END
                if (!!containImage || !!fallbackUsed) {
                    $centerCropped.addClass("contained");
                }
            }
            var $backgroundDce = $element.closest(".background");
            if ($backgroundDce.length > 0) {
                //$backgroundDce.css("background-image", 'url(' + replacementUrl + ')');
                //$backgroundDce.css({"background-image":"url(" + replacementUrl + ")", "background-color":"hsla(0,0%,79%,0.1)"}); // $medium-gray
                // remove Background https://ticket.pixelpoint.at/issues/30139#note-76
                /*$backgroundDce.css({
                    "background-image": "url(" + replacementUrl + ")",
                    "background-color": "#E9EEF2"
                });*/
                $backgroundDce.css({
                    "background-image": "url(" + replacementUrl + ")"
                });
                // END
                if (!!containImage || !!fallbackUsed) {
                    $backgroundDce.addClass("contained");
                }
            }

            var $dceImageWrapper = $element.closest(".dceimagewrapper");
            if ($dceImageWrapper.length > 0) {
                $dceImageWrapper.css("display", "block");
            }
        }
    }

    //*****************we hide some images*******************************************

    //*******************************************************************************
    //*

    function testImages(element) {
        return;

        element.find("img").addBack("img").each(function () {
            if (this.complete) {
                if (typeof this.naturalWidth == "undefined" || this.naturalWidth == 0 || $(this).hasClass("image-load-error")) {
                    $(this).removeClass("image-load-error");
                    var self = this;
                    var img = new Image();
                    img.onerror = function () {
                        if ($(self).is("[data-hide-on-error]")) {
                            $(self).css({
                                opacity: 0
                            });
                            return;
                        }
                        var errorCallback = $(self).data("image-error-callback");
                        if (errorCallback) {
                            if (!!errorCallbacks[errorCallback]) {
                                _.each(errorCallbacks, (callback) => {
                                    callback($(self));
                                });
                            } else {
                                privateFunctions.replaceImage($(self));
                            }
                        } else {
                            privateFunctions.replaceImage($(self));
                        }

                    }
                    img.src = this.src;
                }
            }
        });
    }


    function initializeImageErrors(element) {
        return;

        element.find("img").addBack("img").each(function () {
            $(this).on("error", function (e) {
                var $img = $(e.target);

                if ($img.is("[data-hide-on-error]")) {
                    $img.css({
                        opacity: 0
                    });
                    return;
                }

                var errorCallback = $img.data("image-error-callback");
                var defaultCallback = ($img) => {
                    $img.off("error").one("error", function (e) {
                        privateFunctions.replaceWithAlternative($img);
                    });
                    privateFunctions.replaceImage($img);
                };
                if (errorCallback) {
                    if (!!errorCallbacks[errorCallback]) {
                        _.each(errorCallbacks, (callback) => {
                            callback($img);
                        });
                    } else {
                        defaultCallback($img);
                    }
                } else {
                    defaultCallback($img);
                }
            });
        });
        testImages(element);
    }

    window.executeAfterConsentExists(() => {
        initializeImageErrors($("body"));
    })

    $("body").on("lazyLoadError", function (e, __, image, imageSource) {
        return;

        if (image.is("[data-hide-on-error]")) {
            image.css({
                opacity: 0
            });
            return;
        }

        //************************************* */
        var errorCallback = image.data("image-error-callback");
        var defaultCallback = ($img) => {
            $img.off("error").one("error", function (e) {
                privateFunctions.replaceWithAlternative($img);
            });
            privateFunctions.replaceImage($img);
        };
        if (errorCallback) {
            if (!!errorCallbacks[errorCallback]) {
                _.each(errorCallbacks[errorCallback], (callback) => {
                    callback(image);
                });
            } else {
                defaultCallback(image);
            }
        } else {
            defaultCallback(image);
        }
        //************************************* */
    });

    window.pixelpoint.images = {
        initializeErrors: initializeImageErrors,
        testImages: testImages,
        registerCallback: function (name, callback) {
            if (!errorCallbacks[name]) {
                errorCallbacks[name] = [];
            }
            errorCallbacks[name].push(callback);
        },
        deleteCallbacks: function (name) {
            if (!!errorCallbacks[name]) {
                errorCallbacks[name] = [];
            }
        }
    };
});